(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/betslip/betslip-sticky-content.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/betslip/betslip-sticky-content.js');
"use strict";

const SignSeparators = svs.challenge.SignSeparators;
const BetslipStickyContent = _ref => {
  let drawEvents = _ref.drawEvents,
    rowPrice = _ref.rowPrice;
  return React.createElement("div", {
    className: "challenge-betslip-sticky-content"
  }, React.createElement(SignSeparators, {
    drawEvents: drawEvents,
    rowPrice: rowPrice
  }));
};
svs.challenge.BetslipStickyContent = BetslipStickyContent;

 })(window);